<template>
  <v-container fluid>
    <v-card>
        <h1>CONTACTO</h1>
    </v-card>
  </v-container>
</template>